import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import colors from "vuetify/es5/util/colors";

Vue.use(Vuetify, {});

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: colors.green.base,
        secondary: colors.green.lighten2,
        accent: colors.green.accent1,
        error: colors.red.base,
        warning: colors.orange.base,
        info: colors.teal.base,
        success: colors.cyan.base,
      },
    },
  },
});
